import { customAxiosInstanceMutator } from './custom-axios-instance';

export type XdsDataMode =
    | 'LIVE'
    | 'CACHE_1H'
    | 'CACHE_1D'
    | 'CACHE_1W'
    | 'CACHE_1M'
    | 'CACHE_3M'
    | 'CACHE_6M';

export interface CreditBureauSettings {
    enabled: boolean;
    dataMode: XdsDataMode;
}

const STORAGE_KEY = 'maliyone_credit_bureau_settings';

const defaultSettings: CreditBureauSettings = {
    enabled: true,
    dataMode: 'LIVE',
};

export const getCreditBureauSettings = async (): Promise<CreditBureauSettings> => {
    try {
        return await customAxiosInstanceMutator<CreditBureauSettings>({
            url: '/loan/api/v1/settings/credit-bureau',
            method: 'GET',
        });
    } catch {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : defaultSettings;
    }
};

export const saveCreditBureauSettings = async (settings: CreditBureauSettings): Promise<void> => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    try {
        await customAxiosInstanceMutator<void>({
            url: '/loan/api/v1/settings/credit-bureau',
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            data: settings,
        });
    } catch {
        // Backend API not yet available — settings persisted locally only
    }
};

// ---------------------------------------------------------------------------
// Credit Policy Settings
// ---------------------------------------------------------------------------

export interface CreditPolicySettings {
    /** Last band (inclusive) that maps to Approved. Bands 1..approvedMaxBand = Approved. */
    approvedMaxBand: number;
    /** Last band (inclusive) that maps to Refer. Bands approvedMaxBand+1..referMaxBand = Refer. */
    referMaxBand: number;
    // Rejected = referMaxBand+1..10 (derived, not stored separately)
}

const POLICY_STORAGE_KEY = 'maliyone_credit_policy_settings';

const defaultPolicySettings: CreditPolicySettings = {
    approvedMaxBand: 3,
    referMaxBand: 6,
};

export const getCreditPolicySettings = async (): Promise<CreditPolicySettings> => {
    try {
        return await customAxiosInstanceMutator<CreditPolicySettings>({
            url: '/loan/api/v1/settings/credit-policy',
            method: 'GET',
        });
    } catch {
        const stored = localStorage.getItem(POLICY_STORAGE_KEY);
        return stored ? JSON.parse(stored) : defaultPolicySettings;
    }
};

export const saveCreditPolicySettings = async (settings: CreditPolicySettings): Promise<void> => {
    localStorage.setItem(POLICY_STORAGE_KEY, JSON.stringify(settings));
    try {
        await customAxiosInstanceMutator<void>({
            url: '/loan/api/v1/settings/credit-policy',
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            data: settings,
        });
    } catch {
        // Backend API not yet available — settings persisted locally only
    }
};
